import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import {
  Wrapper,
  InputIconWrapper,
  StyledInput,
  ClearButton,
  AppendedIcon,
  PrependedIcon,
  FloatingLabel,
} from './styles';

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasFocus: false,
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onFocus(ev) {
    this.setState({ hasFocus: true });

    this.props.onFocus(ev);
  }

  onBlur(ev) {
    this.setState({ hasFocus: false });

    this.props.onBlur(ev);
  }

  render() {
    const {
      className,
      isClearable,
      size,
      isLoading,
      onForwardedRef,
      innerRef,
      hasFloatingPlaceholder,
      placeholder,
      ...inputProps
    } = this.props;

    const { hasFocus } = this.state;

    return (
      <Wrapper className={className} size={size}>
        {hasFloatingPlaceholder && placeholder && (
          <FloatingLabel
            isFloating={
              hasFocus ||
              (!isNil(inputProps.value) && inputProps.value !== '') ||
              (!isNil(inputProps.defaultValue) && inputProps.defaultValue !== '')
            }
          >
            {placeholder}
          </FloatingLabel>
        )}

        <StyledInput
          {...inputProps}
          placeholder={hasFloatingPlaceholder ? null : placeholder}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          size={size}
          ref={onForwardedRef || innerRef}
        />

        {inputProps.prependIcon && (
          <InputIconWrapper isPrepended>
            <PrependedIcon className={inputProps.prependIcon} />
          </InputIconWrapper>
        )}

        {!isLoading && inputProps.appendIcon && (
          <InputIconWrapper isAppended>
            <AppendedIcon className={inputProps.appendIcon} />
          </InputIconWrapper>
        )}

        {isLoading && (
          <InputIconWrapper isAppended>
            <AppendedIcon className="fa fa-circle-notch fa-spin" />
          </InputIconWrapper>
        )}

        {isClearable && get(inputProps, 'value', '') !== '' && (
          <InputIconWrapper isAppended>
            <ClearButton
              appearance={inputProps.appearance}
              onClick={() => inputProps.onChange({ target: { value: '' } })}
            />
          </InputIconWrapper>
        )}
      </Wrapper>
    );
  }
}

Input.defaultProps = {
  prependIcon: null,
  appendedIcon: null,
  appearance: 'default',
  size: 'normal',
  version: 'legacy',
  isClearable: false,
  isLoading: false,
  onFocus: () => {},
  onBlur: () => {},
  placeholder: null,
  hasFloatingPlaceholder: false,
};

Input.propTypes = {
  appearance: PropTypes.oneOf(['default', 'rounded']),
  size: PropTypes.oneOf(['small', 'normal', 'big']),
  version: PropTypes.oneOf(['legacy', 'abby']),
  prependIcon: PropTypes.string,
  appendedIcon: PropTypes.string,
  isClearable: PropTypes.bool,
  isLoading: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  hasFloatingPlaceholder: PropTypes.bool,
};

const InputWithForwardedRef = React.forwardRef((props, ref) => <Input {...props} innerRef={ref} />);

InputWithForwardedRef.PrependedIcon = PrependedIcon;
InputWithForwardedRef.AppendedIcon = AppendedIcon;
InputWithForwardedRef.StyledInput = StyledInput;

InputWithForwardedRef.Small = React.forwardRef((props, ref) => (
  <Input {...props} innerRef={ref} size="small" />
));
InputWithForwardedRef.Big = React.forwardRef((props, ref) => (
  <Input {...props} innerRef={ref} size="big" />
));

export default InputWithForwardedRef;
